// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rmomqqdcuwgeapmtwcuc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtb21xcWRjdXdnZWFwbXR3Y3VjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM3Nzk0NTMsImV4cCI6MjA0OTM1NTQ1M30.Vl8z9q6wuv54mLBxSGeKKWfYbrLoedFiwu46re8yTnc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);